import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.SignpostContentPromoLinkList = class SignpostContentPromoLinkList extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-content-promo-signpost-linklist';
	}

	constructor(element) {
		super(element);
	}

	render() {

	}
};



// WEBPACK FOOTER //
// ./components/signpostContentPromoLinkList/scripts/signpostContentPromoLinkList.js